/**
* @Description 文件功能说明：上传预览弹窗
* @Author 张彬
* @Time 2021/3/13 11:33
**/

/* HTML */
<template>
    <div v-if="dialogTreeItem.dialogFormVisible">
        <el-dialog :title="dialogTreeItem.title"
                   :visible.sync="dialogTreeItem.dialogFormVisible"
                   :close-on-click-modal="false"
                   custom-class="form-dialog"
                   v-dialogDrag
                   class="dialog_title"
                   @close="handleDialogClose"
        >
          <SubVideoJS ref="subVideoJS" :options="videoOptions"></SubVideoJS>
        </el-dialog>
    </div>

</template>

/* JS */
<script>

import SubVideoJS from "../../components/SubVideo/SubVideoJS";
export default {

    /**
     * @Des 组件名
     * @Auth Zhangbin
     * @Date 17:22 2021/4/30
     */
    name: 'AlarmVideoDialog',

    /**
     * @Des 组件引用
     * @Auth Zhangbin
     * @Date 17:22 2021/4/30
     */
    components: {
      SubVideoJS
    },

    /**
     * @Des 数据接收类型
     * @Auth Zhangbin
     * @Date 17:22 2021/4/30
     */
    props: {

    },

    /**
     * @Des 数据定义
     * @Auth Zhangbin
     * @Date 17:23 2021/4/30
     */
    data() {
        return{
            /**
             * @Des 弹出层属性
             * @Auth Zhangbin
             * @Date 17:23 2021/4/30
             */
            dialogTreeItem: {
                title: '',
                dialogFormVisible: false,
            },
            videoOptions: {
              autoplay: true,
              controls: true,
              sources: []
            }
        }
    },

    /**
     * @Des 方法定义
     * @Auth Zhangbin
     * @Date 17:24 2021/4/30
     */
    methods: {

        /**
         * @Des 打开弹窗
         * @Auth Zhangbin
         * @Date 17:24 2021/4/30
         */
        openDialog(title, data){
            this.dialogTreeItem.title = title;
            this.dialogTreeItem.dialogFormVisible = true;
            this.videoOptions.sources = Object.assign([], [])
            if(data.length > 0){
                for(let item in data){
                    this.videoOptions.sources.push({
                        id: item.id,
                        src: item.value,
                        type: "video/mp4"
                    })
                }
            }
        },

        /**
         * @Des 关闭弹窗
         * @Auth Zhangbin
         * @Date 17:24 2021/4/30
         */
        handleDialogClose(){
            this.dialogTreeItem.dialogFormVisible = false;
        },

    },

}
</script>

/* CSS */
<style lang="scss" scoped>
	/deep/ .el-dialog{
        margin-top: 100px;
        width: 95%;
    }
</style>



// WEBPACK FOOTER //
// src/components_pages/Alarm/AlarmVideoDialog.vue